// 主題：深色（預設）、淺色、跟隨系統。選擇記在瀏覽器；實際套用的主題寫在 <html data-theme>。
// 首次繪製前由 public/theme-init.js 先套用（避免閃白），這裡負責之後的切換與系統設定變化。
import { type KeyValueStore, readJson, writeJson } from '../../storage/storage.ts';

export const THEME_KEY = 'dayone:v1:theme';
export const THEME_PREFS = ['dark', 'light', 'system'] as const;
export type ThemePref = (typeof THEME_PREFS)[number];
export type Theme = 'dark' | 'light';

export const DEFAULT_THEME: ThemePref = 'dark';

export function sanitizeTheme(raw: unknown): ThemePref {
  return THEME_PREFS.includes(raw as ThemePref) ? (raw as ThemePref) : DEFAULT_THEME;
}

export function loadTheme(store?: KeyValueStore | null): ThemePref {
  return sanitizeTheme(readJson(THEME_KEY, store));
}

export function saveTheme(pref: ThemePref, store?: KeyValueStore | null): boolean {
  return writeJson(THEME_KEY, pref, store);
}

export function resolveTheme(pref: ThemePref, systemPrefersLight: boolean): Theme {
  if (pref === 'system') return systemPrefersLight ? 'light' : 'dark';
  return pref;
}

/** 寫到 <html>：CSS 依 data-theme 切換 token，另外同步瀏覽器 UI 顏色（手機網址列） */
export function applyTheme(theme: Theme, doc: Document = document): void {
  const root = doc.documentElement;
  if (root.dataset.theme !== theme) root.dataset.theme = theme;
  const meta = doc.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', theme === 'light' ? '#f5f4f1' : '#0b0c0f');
}
